<div *ngIf="!environmentMode.production" class="environment-banner">
  <p class="txtDisplay">{{ txtDisplay | translate }}</p>
</div>
